module.exports = __webpack_public_path__ + "static/nazar-9bb5ff5ed89d4630bb795cca22aa4871.jpg";